import { memo } from 'react';
import cn from 'classnames';

import BrText from '@components/BrText';
import './brLabel.scss';

type BrLabelProps = {
  title: string;
  preIcon?: React.ReactNode;
  postIcon?: React.ReactNode;
  className?: string;
  isDisabled?: boolean;
  isSubComp?: boolean;
  onClick?: () => (event: React.MouseEvent<HTMLDivElement>) => void;
};

const BrLabel = (props: BrLabelProps): JSX.Element => {
  const { title, preIcon, postIcon, className, onClick, isDisabled, isSubComp } = props;

  const btnClass = cn('br-label', className, {
    disabled: isDisabled,
    'sub-comp': isSubComp,
  });
  const handleOnClick = isDisabled ? undefined : onClick;

  return (
    <div className={btnClass} onClick={handleOnClick} data-id="br-label">
      {preIcon}
      {typeof title === 'string' ? (
        <div className="br-label-title" title={title}>
          <BrText>{title}</BrText>
        </div>
      ) : (
        title
      )}
      {postIcon}
    </div>
  );
};

export default memo(BrLabel);
